













import NavBar from './components/NavBar.vue';
import Vue from 'vue';

export default Vue.extend({
    name: 'app',
    components : { NavBar },
    methods: {
        async login() : Promise<void> {
            try {
                await this.$store.dispatch('user/login');
            } catch (err) {
                console.error(err);
                window.alert(`Something went wrong: ${err.message}`);
            }
        },
        async logout() : Promise<void> {
            try {
                if (window.confirm('Are you sure you want to logout?')) {
                    await this.$store.dispatch('autosave/autosave');
                    await this.$store.dispatch('user/logout');
                }
            } catch (err) {
                console.error(err);
                window.alert(`Something went wrong: ${err.message}`);
            }
        },
    },
});
